import { PROFILE_AI_SUMMARY_WIDGET_WARNING } from '../../../Widget'

export function getEmailProfileAISummaryUnavailableData() {
  return {
    can_generate: false,
    warnings: [PROFILE_AI_SUMMARY_WIDGET_WARNING.temporaryUnavailable],
  }
}
